import React from 'react';
import '../../components/style.css';
import Image from '../../pics';
import { Link } from 'react-router-dom';

function banner() {
  return (
    <div>
        <div className='bg-primary sect-spacer'>
            <div className="uk-container">
                <div className="uk-child-width-1-2@s uk-grid-match" data-uk-grid>   
                    <div>
                        <div className="uk-card">
                            <img src={Image.SERVICEPAGE} alt="service page banner img" width='100%' />
                        </div>
                    </div>
                    <div className='align-items-center'>
                        <div className="uk-card">
                            <h2 className="text-primary uk-text-left">
                                STARTOS Services 
                            </h2>
                            <p className='uk-text-left text-secondary uk-text-justify'>
                                STARTOS offer’s several types of services for business to business customers also prioritizes the safety and security of their shipments all time. Once booking accepted, your shipments will be scheduled, picked up, scanned, re-measured, processed, bagged, sealed, and manifested for high security during all transit point till it reaches destination area, STRATOS operate between Tiruppur, Delhi, Noida, Gurugram, Faridabad and many more cities. Additionally, we offer same-day delivery services for your at most priority goods.
                            </p>
                            <div className="uk-text-left">
                                <Link to="/contact" className="uk-text-capitalize">
                                    <button>
                                        Book Now
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default banner